import axios from "axios";
import { getCookie } from "./manage_cookies";
import env from "../env";

const baseURL = env.BACKEND_BASE_URL + 'api/';
const localURL = env.FRONTEND_BASE_URL;


const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});


http.interceptors.request.use((config) => {
  const csrfToken = getCookie("csrftoken");

  if (csrfToken) {
    config.headers["X-CSRFToken"] = csrfToken;
  }

  return config;
});


export const httpLocal = axios.create({
  baseURL: localURL,
  headers: {
    "Content-type": "application/json",
  },
});

export default http;
